
























































































































































import { Component, Prop, Vue } from "vue-property-decorator";
import AuditPembersihanLingkunganService from "@/services/AuditPembersihanLingkunganService";
import { parseLocalDate } from "@/utils/localDate";
import {
  APL_ITEM_COUNT,
  KATEGORI_AUDIT_PEMBERSIHAN_LINGKUNGAN,
  KELOMPOK_AUDIT_PEMBERSIHAN_LINGKUNGAN,
  KRITERIA_AUDIT_PEMBERSIHAN_LINGKUNGAN,
  KriteriaAuditPembersihanLingkungan,
  PENILAIAN_OPTIONS,
  PenilaianAuditPembersihanLingkungan,
  kategoriAuditPembersihanLingkungan
} from "@/constants/kriteriaAuditPembersihanLingkungan";

interface ResponseRow {
  id?: number;
  kriteria_no: number;
  penilaian: PenilaianAuditPembersihanLingkungan | null;
}

function buildResponseMap(existing: any[]): Record<number, ResponseRow> {
  const byNo: Record<number, any> = {};
  existing.forEach(r => {
    byNo[r.kriteria_no] = r;
  });
  const map: Record<number, ResponseRow> = {};
  KRITERIA_AUDIT_PEMBERSIHAN_LINGKUNGAN.forEach(k => {
    const e = byNo[k.no];
    map[k.no] = {
      id: e?.id,
      kriteria_no: k.no,
      penilaian: (e?.penilaian as PenilaianAuditPembersihanLingkungan) ?? null
    };
  });
  return map;
}

@Component
export default class AuditPembersihanLingkunganKriteriaLogger extends Vue {
  @Prop({ required: true }) readonly sessionId!: number;

  session: any = null;
  sessionNomor = "";
  kriteriaList = KRITERIA_AUDIT_PEMBERSIHAN_LINGKUNGAN;
  kelompokLabel = KELOMPOK_AUDIT_PEMBERSIHAN_LINGKUNGAN;
  penilaianOptions = PENILAIAN_OPTIONS;
  itemCount = APL_ITEM_COUNT;

  responseMap: Record<number, ResponseRow> = buildResponseMap([]);

  saving = false;
  submitting = false;
  submitDialog = false;
  leaveDialog = false;
  submitForm = { password: "" };
  dirty = false;

  async mounted() {
    await this.loadSession();
  }

  async loadSession() {
    const res = await AuditPembersihanLingkunganService.find(this.sessionId);
    this.session = res.data.data;
    this.sessionNomor = this.session.nomor_formulir;
    this.initResponses();
  }

  initResponses() {
    this.responseMap = buildResponseMap(this.session.responses || []);
    this.dirty = false;
  }

  showGroupHeader(k: KriteriaAuditPembersihanLingkungan): boolean {
    const idx = this.kriteriaList.findIndex(x => x.no === k.no);
    const prev = idx > 0 ? this.kriteriaList[idx - 1] : null;
    return !prev || prev.kelompok !== k.kelompok;
  }

  setPenilaian(no: number, value: PenilaianAuditPembersihanLingkungan) {
    const row = this.responseMap[no];
    row.penilaian = row.penilaian === value ? null : value;
    this.markDirty();
  }

  clearAllPenilaian() {
    this.kriteriaList.forEach(k => {
      this.responseMap[k.no].penilaian = null;
    });
    this.markDirty();
  }

  markDirty() {
    this.dirty = true;
  }

  formatHariTanggal(s: string): string {
    const d = parseLocalDate(s);
    if (!d) return "-";
    return d.toLocaleDateString("id-ID", {
      weekday: "long",
      day: "2-digit",
      month: "long",
      year: "numeric"
    });
  }

  get rows(): ResponseRow[] {
    return Object.values(this.responseMap);
  }

  get filledCount(): number {
    return this.rows.filter(r => r.penilaian).length;
  }

  get totalYa(): number {
    return this.rows.filter(r => r.penilaian === "ya").length;
  }

  get totalTidak(): number {
    return this.rows.filter(r => r.penilaian === "tidak").length;
  }

  get overallRate(): number | null {
    const denom = this.totalYa + this.totalTidak;
    return denom > 0 ? Math.round((this.totalYa / denom) * 10000) / 100 : null;
  }

  get overallKategori() {
    const kode = kategoriAuditPembersihanLingkungan(this.overallRate);
    return kode ? KATEGORI_AUDIT_PEMBERSIHAN_LINGKUNGAN[kode] : null;
  }

  get submitBlockedReason(): string {
    if (this.dirty) return "Simpan penilaian terlebih dahulu sebelum TTD Auditor.";
    if (this.totalYa + this.totalTidak === 0) {
      return "TTD Auditor aktif setelah minimal 1 item dinilai Ya atau Tidak dan disimpan.";
    }
    return "";
  }

  get canSubmit(): boolean {
    return !!this.session && !this.submitBlockedReason;
  }

  async saveAll() {
    this.saving = true;
    try {
      const responses = this.rows.map(r => ({
        kriteria_no: r.kriteria_no,
        penilaian: r.penilaian
      }));
      const res = await AuditPembersihanLingkunganService.bulkResponses(this.sessionId, responses);
      this.session = res.data.data;
      this.initResponses();
    } finally {
      this.saving = false;
    }
  }

  requestClose() {
    if (this.dirty) {
      this.leaveDialog = true;
      return;
    }
    this.$emit("close");
  }

  discardAndClose() {
    this.leaveDialog = false;
    this.$emit("close");
  }

  openSubmitDialog() {
    this.submitForm = { password: "" };
    this.submitDialog = true;
  }

  async confirmSubmit() {
    this.submitting = true;
    try {
      await AuditPembersihanLingkunganService.submitAuditor(this.sessionId, this.submitForm);
      this.submitDialog = false;
      this.$emit("submitted", this.sessionId);
    } finally {
      this.submitting = false;
    }
  }
}
